export default __webpack_public_path__ + "9fe80535f0c28fdadc9bd6135c3f4a64.png";